import { Icon } from '@app/components/Atoms/Icon'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import type { ColumnDef } from '@tanstack/react-table'
import { DataModuleRow } from '../types'
import { Link as RouterLink } from 'react-router-dom'
import { Typography } from '@mui/material'

export const columns: ColumnDef<DataModuleRow>[] = [
  {
    accessorKey: 'label',
    header: 'Type',
    cell: (info) => info.getValue<string>(),
    size: 120,
  },
  {
    accessorKey: 'category',
    header: 'Category',
    cell: (info) => info.getValue<string>(),
    size: 180,
  },
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row, getValue }) => {
      const name = getValue<string>()
      const icon = row.original.icon

      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          {icon ? <Icon iconName={icon} /> : null}
          <Link
            component={RouterLink}
            to={`/app/home/data/detail/${row.original.type}`}
            underline="hover"
            sx={{
              minWidth: 0,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              lineHeight: 1.3,
            }}
            title={name}
          >
            {name}
          </Link>
        </Box>
      )
    },
    size: 260,
    sortingFn: 'alphanumeric',
  },
  {
    accessorKey: 'group',
    header: 'Group',
    cell: (info) => info.getValue<string | null>() ?? '—',
    size: 160,
  },
  {
    accessorKey: 'owner',
    header: 'Owner',
    cell: (info) => info.getValue<string | null>() ?? '—',
    size: 160,
  },
  {
    accessorKey: 'confidenceRating',
    header: 'Confidence',
    cell: (info) => info.getValue<string | null>() ?? '—',
    size: 120,
  },
  {
    accessorKey: 'lastUpdated',
    header: 'Last updated',
    cell: (info) => info.getValue<string | null>() ?? '—',
    size: 140,
  },
  {
    accessorKey: 'unit',
    header: 'Unit',
    cell: (info) => info.getValue<string | null>() ?? '—',
    size: 140,
  },
  {
    id: 'actions',
    header: 'Actions',
    enableSorting: false,
    cell: ({ row }) => (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Typography fontWeight={600}>
          <Link
            component={RouterLink}
            to={`/app/home/data/detail/${row.original.type}`}
            underline="hover"
          >
            View
          </Link>
        </Typography>
      </Box>
    ),
    size: 140,
  },
]
